import { Box, Stack } from '@chakra-ui/react';

import Search from '@/components/search/Search';
import { ProjectActionsDropdown } from './ProjectActionsDropdown';

export default function Topbar() {
  return (
    <Stack
      style={{
        width: '100%',
        borderRadius: '0.375rem',
        alignItems: 'center',
      }}
      direction={{ base: 'column', lg: 'row' }}
      justifyContent={{ base: 'center', md: 'space-between' }}
    >
      <ProjectActionsDropdown />

      <Search />
    </Stack>
  );
}
